export enum ActiveType {
	INACTIVE = 0,
	ACTIVE =  1
}


